<template>
  <b-card v-if="studentInfo">
    <b-media no-body>
      <b-media-aside>
        <b-link>
          <b-img
            ref="refPreviewEl"
            rounded
            :src="studentInfo.avatar"
            height="80"
          />
        </b-link>
        <!--/ avatar -->
      </b-media-aside>

      <b-media-body class="mt-75 ml-75">
        <!-- upload button -->
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          size="sm"
          class="mb-75 mr-75"
          @click="$refs.refInputEl.$el.click()"
        >
          Upload
        </b-button>
        <b-form-file
          ref="refInputEl"
          v-model="avatar"
          accept=".jpg, .png, .gif"
          :hidden="true"
          plain
          @input="inputImageRenderer"
        />
        <!--/ upload button -->
        <b-card-text>Cho phép file JPG, GIF hoặc PNG. Kích thước tối đa 800kB</b-card-text>
        <b-button
          v-if="exportStudentInfo"
          v-b-modal.modal
          variant="success"
          @click="exportWord('docx')"
        >
          <span class="text-nowrap text-right">
            <feather-icon icon="DownloadIcon" /> Sổ quản lý sinh viên
          </span>
        </b-button>
      </b-media-body>
    </b-media>

    <b-form class="mt-2">
      <b-row>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Mã sinh viên"
            label-for="student_code"
          >
            <b-form-input
              id="student_code"
              v-model="studentInfo.student_code"
              class="uniform-height"
              name="student_code"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Họ và tên"
            label-for="student_name"
          >
            <b-form-input
              id="student_name"
              v-model="studentInfo.student_name"
              class="uniform-height"
              name="student_name"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Giới tính"
            label-for="student_gender_detail"
          >
            <v-select
              v-model="studentInfo.gender"
              label="name"
              class="uniform-height"
              :options="allGenders"
              :reduce="option => +option.code"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="CMT/CCCD"
            label-for="student_identify_code"
          >
            <b-form-input
              id="student_identify_code"
              v-model="studentInfo.student_identify_code"
              class="uniform-height"
              name="student_identify_code"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Ngày sinh"
            label-for="student_birthday"
          >
            <date-picker
              v-model="studentInfo.student_birthday"
              class="w-100 uniform-height"
              format="DD/MM/YYYY"
              :value-type="'format'"
              default-value
              editable
              clearable
              :lang="'vi'"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Nơi sinh"
            label-for="student_birth_place"
          >
            <b-form-input
              id="student_birth_place"
              v-model="studentInfo.student_birth_place"
              name="student_birth_place"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Quê quán"
            label-for="student_hometown"
          >
            <b-form-input
              id="student_hometown"
              v-model="studentInfo.student_hometown"
              class="uniform-height"
              name="student_hometown"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Loại khuyết tật"
            label-for="student_disability"
          >
            <v-select
              v-model="studentInfo.disability"
              class="uniform-height"
              label="name"
              :options="allFactDisabilities"
              :reduce="option => option.code"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Quốc tịch"
            label-for="student_nationality"
          >
            <v-select
              v-model="studentInfo.nationality"
              class="uniform-height"
              label="name"
              :options="allFactNationalities"
              :reduce="option => option.code"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Tỉnh/thành phố"
            label-for="student_province"
          >
            <v-select
              v-model="studentInfo.province_code"
              label="name"
              class="uniform-height"
              :options="allFactProvinces"
              :reduce="option => option.code"
              @input="onProvinceChange"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Quận/huyện"
            label-for="student_district"
          >
            <v-select
              v-model="studentInfo.district_code"
              label="name"
              class="uniform-height"
              :options="allFactDistricts"
              :reduce="option => option.code"
              @input="onDistrictChange"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Phường/xã"
            label-for="student_ward"
          >
            <v-select
              v-model="studentInfo.ward_code"
              label="name"
              class="uniform-height"
              :options="allFactWards"
              :reduce="option => option.code"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Email"
            label-for="student_email"
          >
            <b-form-input
              id="student_email"
              v-model="studentInfo.student_email"
              class="uniform-height"
              name="student_email"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Số điện thoại"
            label-for="student_mobile"
          >
            <b-form-input
              id="student_gender_detail"
              v-model="studentInfo.student_mobile"
              class="uniform-height"
              name="student_mobile"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Số bảo hiểm"
            label-for="student_social_insurance"
          >
            <b-form-input
              id="student_social_insurance"
              v-model="studentInfo.student_social_insurance"
              class="uniform-height"
              name="student_social_insurance"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Dân tộc"
            label-for="student_ethnic"
          >
            <v-select
              v-model="studentInfo.ethnic_code"
              label="name"
              class="uniform-height"
              :options="allFactEthnics"
              :reduce="option => option.code"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Họ tên cha"
            label-for="fatherFullName"
          >
            <b-form-input
              id="fatherFullName"
              v-model="studentInfo.fatherFullName"
              class="uniform-height"
              name="fatherFullName"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Năm sinh cha"
            label-for="fatherYearOfBirth"
          >
            <b-form-input
              id="fatherYearOfBirth"
              v-model="studentInfo.fatherYearOfBirth"
              class="uniform-height"
              name="fatherYearOfBirth"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Nghề nghiệp cha"
            label-for="fatherOccupation"
          >
            <b-form-input
              id="fatherOccupation"
              v-model="studentInfo.fatherOccupation"
              class="uniform-height"
              name="fatherOccupation"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Số điện thoại cha"
            label-for="fatherPhoneNumber"
          >
            <b-form-input
              id="fatherPhoneNumber"
              v-model="studentInfo.fatherPhoneNumber"
              class="uniform-height"
              name="fatherPhoneNumber"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Họ tên mẹ"
            label-for="motherFullName"
          >
            <b-form-input
              id="motherFullName"
              v-model="studentInfo.motherFullName"
              class="uniform-height"
              name="motherFullName"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Năm sinh mẹ"
            label-for="motherYearOfBirth"
          >
            <b-form-input
              id="motherYearOfBirth"
              v-model="studentInfo.motherYearOfBirth"
              class="uniform-height"
              name="motherYearOfBirth"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Nghề nghiệp mẹ"
            label-for="motherOccupation"
          >
            <b-form-input
              id="motherOccupation"
              v-model="studentInfo.motherOccupation"
              class="uniform-height"
              name="motherOccupation"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Số điện thoại mẹ"
            label-for="motherPhoneNumber"
          >
            <b-form-input
              id="motherPhoneNumber"
              v-model="studentInfo.motherPhoneNumber"
              class="uniform-height"
              name="motherPhoneNumber"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Email phụ huynh"
            label-for="parentEmail"
          >
            <b-form-input
              id="parentEmail"
              v-model="studentInfo.parentEmail"
              class="uniform-height"
              name="parentEmail"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Số điện thoại phụ huynh"
            label-for="phoneNumberParent"
          >
            <b-form-input
              id="phoneNumberParent"
              v-model="studentInfo.phoneNumberParent"
              class="uniform-height"
              name="phoneNumberParent"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Tôn giáo"
            label-for="student_religion"
          >
            <v-select
              v-model="studentInfo.religion_code"
              label="name"
              class="uniform-height"
              :options="allFactReligions"
              :reduce="option => option.code"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Ngày vào đoàn"
            label-for="student_date_youth_group"
          >
            <date-picker
              v-model="studentInfo.date_youth_group"
              class="w-100 uniform-height"
              format="DD/MM/YYYY"
              :value-type="'YYYY-MM-DD'"
              default-value
              editable
              clearable
              :lang="'vi'"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Ngày vào đảng"
            label-for="student_date_dangcongsan_group"
          >
            <date-picker
              v-model="studentInfo.date_dangcongsan_group"
              class="w-100 uniform-height"
              format="DD/MM/YYYY"
              :value-type="'YYYY-MM-DD'"
              default-value
              editable
              clearable
              :lang="'vi'"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Ngày vào đảng chính thức"
            label-for="student_date_dangcongsan_group_chinhthuc"
          >
            <date-picker
              v-model="studentInfo.date_dangcongsan_group_chinhthuc"
              class="w-100 uniform-height"
              format="DD/MM/YYYY"
              :value-type="'YYYY-MM-DD'"
              default-value
              editable
              clearable
              :lang="'vi'"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="6"
          xl="3"
        >
          <b-form-group
            label="Đã học lớp cảm tỉnh đảng"
            label-for="has_learn_party"
          >
            <v-select
              v-model="studentInfo.has_learn_party"
              :options="hasLearnPartySelect"
              class="uniform-height"
              :reduce="option => option.value"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="text-right">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-1"
              @click="onUpdateStudent"
            >
              <span class="text-nowrap text-right">
                <feather-icon icon="CheckIcon" /> Lưu
              </span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              @click="exportHoSo"
            >
              <span class="text-nowrap text-right"><feather-icon icon="DownloadIcon" /> Tải excel</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row />
    </b-form>

    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      no-wrap
      :show="isLoading"
    />
  </b-card>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BFormInput,
  BFormGroup,
  BRow, BForm, BMediaAside, BMedia, BLink, BImg, BMediaBody, BFormFile, BCardText,
  BOverlay,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import { showErrorToast, showSuccessToast, showWarningToast } from '@/utils/notification'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import { HAS_LEARN_PARTY } from '@/const/status'
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { Flag } from '@/const/flag'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import DatePicker from 'vue2-datepicker'
import api from './api'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/vi'

export default {
  name: 'CurriculumVitaeInfo',
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    BForm,
    BFormInput,
    BFormGroup,
    BButton,
    BCard,
    BCol,
    BRow,
    BMedia,
    BMediaAside,
    BLink,
    BImg,
    BMediaBody,
    BFormFile,
    BCardText,
    BOverlay,
    DatePicker,
  },
  props: {
    studentInfo: {
      type: Object,
      default: null,
    },
    studentId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isLoading: false,
      isCreateReceipt: true,
      filter: {
        student_id: this.$route.params.id || this.studentId,
      },
      filterExport: {
        studentClassId: null,
        type: null,
      },
      revenue_fields: [
        { key: 'semester_name', label: 'Kỳ học' },
        { key: 'subject_name', label: 'Môn học' },
        { key: 'total_credit_num', label: 'Số tín chỉ' },
        { key: 'amount', label: 'Số tiền' },
      ],
      revenue_items: [],
      exemption_fields: [
        { key: 'semester_name', label: 'Kỳ học' },
        { key: 'revenue_name', label: 'Loại miễn giảm' },
        { key: 'amount', label: 'Số tiền' },
      ],
      exemption_items: [],
      avatar: null,
      genderSelect: [],
    }
  },
  computed: {
    ...mapGetters({
      dataExport: 'curriculumVitae/dataExport',
      allFactEthnics: 'curriculumVitae/allFactEthnics',
      allFactDisabilities: 'curriculumVitae/allFactDisabilities',
      allFactReligions: 'curriculumVitae/allFactReligions',
      allFactProvinces: 'curriculumVitae/allFactProvinces',
      allFactDistricts: 'curriculumVitae/allFactDistricts',
      allFactWards: 'curriculumVitae/allFactWards',
      allFactNationalities: 'curriculumVitae/allFactNationalities',
      allGenders: 'factGender/dataSources',
    }),
    hasLearnPartySelect() {
      return HAS_LEARN_PARTY.map(item => ({ value: item.value, label: item.label }))
    },
    exportStudentInfo() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.READ, ResourceCode.TNH_REPORT_STUDENT_MANAGEMENT_REGISTER)
    },
  },
  watch: {
    async studentInfo(val) {
      if (val) {
        this.isLoading = true
        try {
          await Promise.all([
            this.getFactEthnics(),
            this.getFactDisabilities(),
            this.getFactReligions({ currentPage: 1, itemsPerPage: 1000, status: Flag.ACTIVE }),
            this.getFactProvinces({ currentPage: 1, itemsPerPage: 1000, status: Flag.ACTIVE }),
            this.getFactNationalities({ currentPage: 1, itemsPerPage: 1000, status: Flag.ACTIVE }),
            this.getGenders({ currentPage: 1, itemsPerPage: 100 }),
            this.getDistrict({ province_code: this.studentInfo.province_code }),
            this.getWard({
              province_code: this.studentInfo.province_code,
              district_code: this.studentInfo.district_code,
            }),
          ])
        } catch (e) {
          showErrorToast(this, e)
        } finally {
          this.isLoading = false
        }
      }
    },
  },
  methods: {
    ...mapActions({
      getDataExport: 'curriculumVitae/downloadExport',
      getFactEthnics: 'curriculumVitae/getFactEthnics',
      getFactDisabilities: 'curriculumVitae/getFactDisabilities',
      getFactReligions: 'curriculumVitae/getFactReligions',
      getFactProvinces: 'curriculumVitae/getFactProvinces',
      getFactNationalities: 'curriculumVitae/getFactNationalities',
      updateStudentInfo: 'curriculumVitae/updateStudentInfo',
      getDistrict: 'curriculumVitae/getDistrict',
      getWard: 'curriculumVitae/getWard',
      getGenders: 'factGender/getDataSources',
    }),
    async onProvinceChange(event) {
      this.studentInfo.province_code = event
      await this.getDistrict({ province_code: event })
      this.studentInfo.district_code = null
      this.studentInfo.ward_code = null
    },
    async onDistrictChange(event) {
      this.studentInfo.district_code = event
      await this.getWard({ province_code: this.studentInfo.province_code, district_code: event })
      this.studentInfo.ward_code = null
    },
    async exportHoSo() {
      await this.getDataExport(this.filter)

      const a = document.createElement('a')
      document.body.appendChild(a)
      const blob = new Blob([this.dataExport.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = `ho_so_sinh_vien_${this.studentInfo.student_name}.xlsx`
      a.click()
      window.URL.revokeObjectURL(url)
    },
    generateFileName(studentName, studentCode, extension = 'docx') {
      const name = studentName || 'SinhVien'
      const code = studentCode || ''

      const normalizedName = name
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D')
        .replace(/\s+/g, '_')
        .trim()

      return code ? `${normalizedName}_${code}.${extension}` : `${normalizedName}.${extension}`
    },
    async exportWord(type) {
      this.filterExport.type = type
      this.filterExport.studentClassId = this.studentInfo.studentClassId
      this.isLoading = true
      try {
        const data = await api.downloadWord(this.filterExport)
        if (data) {
          const fileName = this.generateFileName(
            this.studentInfo.student_name,
            this.studentInfo.student_code,
            type
          )
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = fileName
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
        } else {
          showWarningToast(this, 'File không có dữ liệu')
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    columnFilterFn() {},
    async onUpdateStudent() {
      this.isLoading = true
      try {
        const response = await this.updateStudentInfo(this.studentInfo)
        if (response) {
          const { isSuccessful, message } = response
          if (isSuccessful) {
            showSuccessToast(this, message)
            this.$emit('succeed')
          } else {
            showErrorToast(this, message)
          }
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
  },
  setup() {
    const refInputEl = ref(null)
    const refPreviewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => { refPreviewEl.value.src = base64 })

    return {
      refInputEl,
      refPreviewEl,
      inputImageRenderer,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.uniform-height {
  height: 38px;
}
.uniform-height .mx-input {
  height: 38px;
}
.uniform-height .vs__dropdown-toggle {
  height: 38px;
  min-height: 38px;
}
</style>
